import { render, staticRenderFns } from "./news-item.vue?vue&type=template&id=3034671a&scoped=true&"
import script from "./news-item.vue?vue&type=script&lang=js&"
export * from "./news-item.vue?vue&type=script&lang=js&"
import style0 from "./news-item.vue?vue&type=style&index=0&id=3034671a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3034671a",
  null
  
)

export default component.exports